module.exports = __webpack_public_path__ + "img/C04TechBowmanS_ua.d6a6e849.webp";